export default __webpack_public_path__ + "static/media/thumbnail.f34d25ea.png";